// Shared workspace copy: every supported locale must define the same keys.
export const workspaceTranslations = {
  "es": {
    "briefy": {
      "talk": "Hablar con BRIEFY"
    },
    "design": {
      "briefyAssist": "te ayuda en cada paso.",
      "briefyHere": "BRIEFY te ayuda en cada paso.",
      "dashboardTitle": "Tu negocio, bajo control",
      "originalImage": "Imagen original",
      "mintBusiness": "Negocio luminoso",
      "changeImage": "Cambiar imagen",
      "chooseBanner": "Elige el fondo de esta página",
      "bannerScope": "Cada página puede tener su propia imagen. Tu elección se guarda en este navegador.",
      "storageUnavailable": "El cambio se muestra ahora, pero este navegador no permite guardarlo.",
      "restore": "Restaurar original"
    },
    "branding": {
      "ownCover": "Portada de mi negocio"
    },
    "common": {
      "done": "Listo"
    },
    "nav": {
      "dashboard": "Inicio",
      "financesDashboard": "Panel financiero",
      "relatedModules": "Módulos relacionados"
    },
    "dashboard": {
      "title": "Inicio"
    },
    "comeback": {
      "cardText": "clientes llevan 3 o más semanas sin visitarte",
      "cardTextOne": "cliente lleva 3 o más semanas sin visitarte",
      "cta": "Enviar oferta por correo",
      "ctaShort": "Enviar oferta",
      "title": "Campaña de regreso",
      "desc": "Se enviará un correo con tu oferta a los",
      "desc2": "clientes inactivos (los que no tengan correo se omiten). Usa",
      "desc3": "para personalizar.",
      "subject": "Asunto",
      "subjectPh": "¡Te extrañamos! (por defecto)",
      "message": "Mensaje",
      "messagePh": "Hola {nombre}, ha pasado un tiempo desde tu última visita... (mensaje por defecto si lo dejas vacío)",
      "sending": "Enviando...",
      "send": "Enviar ahora",
      "sentOk": "Oferta enviada a {count} cliente(s)",
      "skipped": "{count} sin correo",
      "noneSent": "Ningún cliente inactivo tiene correo registrado",
      "sendError": "Error al enviar la campaña"
    }
  },
  "en": {
    "briefy": {
      "talk": "Talk to BRIEFY"
    },
    "design": {
      "briefyAssist": "helps you every step of the way.",
      "briefyHere": "BRIEFY helps you every step of the way.",
      "dashboardTitle": "Your business, under control",
      "originalImage": "Original image",
      "mintBusiness": "Bright business",
      "changeImage": "Change image",
      "chooseBanner": "Choose this page’s background",
      "bannerScope": "Each page can have its own image. Your choice is saved in this browser.",
      "storageUnavailable": "The change is visible now, but this browser cannot save it.",
      "restore": "Restore original"
    },
    "branding": {
      "ownCover": "My business cover"
    },
    "common": {
      "done": "Done"
    },
    "comeback": {
      "cardText": "customers have not visited in 3 or more weeks",
      "cardTextOne": "customer has not visited in 3 or more weeks",
      "cta": "Email an offer",
      "ctaShort": "Send offer",
      "title": "Welcome-back campaign",
      "desc": "Your offer will be emailed to",
      "desc2": "inactive customers (those without an email are skipped). Use",
      "desc3": "to personalize it.",
      "subject": "Subject",
      "subjectPh": "We miss you! (default)",
      "message": "Message",
      "messagePh": "Hi {nombre}, it has been a while since your last visit... (default message if left blank)",
      "sending": "Sending...",
      "send": "Send now",
      "sentOk": "Offer sent to {count} customer(s)",
      "skipped": "{count} without an email",
      "noneSent": "No inactive customers have an email address",
      "sendError": "Could not send the campaign"
    },
    "nav": {
      "relatedModules": "Related modules"
    }
  },
  "pt": {
    "briefy": {
      "talk": "Falar com BRIEFY"
    },
    "design": {
      "briefyAssist": "ajuda você em cada etapa.",
      "briefyHere": "BRIEFY ajuda você em cada etapa.",
      "dashboardTitle": "Seu negócio, sob controle",
      "originalImage": "Imagem original",
      "mintBusiness": "Negócio luminoso",
      "changeImage": "Alterar imagem",
      "chooseBanner": "Escolha o fundo desta página",
      "bannerScope": "Cada página pode ter sua própria imagem. Sua escolha é salva neste navegador.",
      "storageUnavailable": "A alteração está visível agora, mas este navegador não permite salvá-la.",
      "restore": "Restaurar original"
    },
    "branding": {
      "ownCover": "Capa do meu negócio"
    },
    "common": {
      "done": "Concluído"
    },
    "comeback": {
      "cardText": "clientes não visitam há 3 ou mais semanas",
      "cardTextOne": "cliente não visita há 3 ou mais semanas",
      "cta": "Enviar oferta por e-mail",
      "ctaShort": "Enviar oferta",
      "title": "Campanha de retorno",
      "desc": "Sua oferta será enviada por e-mail a",
      "desc2": "clientes inativos (aqueles sem e-mail serão ignorados). Use",
      "desc3": "para personalizar.",
      "subject": "Assunto",
      "subjectPh": "Sentimos sua falta! (padrão)",
      "message": "Mensagem",
      "messagePh": "Olá {nombre}, faz um tempo desde sua última visita... (mensagem padrão se ficar em branco)",
      "sending": "Enviando...",
      "send": "Enviar agora",
      "sentOk": "Oferta enviada a {count} cliente(s)",
      "skipped": "{count} sem e-mail",
      "noneSent": "Nenhum cliente inativo tem e-mail cadastrado",
      "sendError": "Não foi possível enviar a campanha"
    },
    "nav": {
      "relatedModules": "Módulos relacionados"
    }
  },
  "fr": {
    "briefy": {
      "talk": "Parler à BRIEFY"
    },
    "design": {
      "briefyAssist": "vous aide à chaque étape.",
      "briefyHere": "BRIEFY vous aide à chaque étape.",
      "dashboardTitle": "Votre entreprise, sous contrôle",
      "originalImage": "Image originale",
      "mintBusiness": "Entreprise lumineuse",
      "changeImage": "Changer l’image",
      "chooseBanner": "Choisissez le fond de cette page",
      "bannerScope": "Chaque page peut avoir sa propre image. Votre choix est enregistré dans ce navigateur.",
      "storageUnavailable": "Le changement est visible, mais ce navigateur ne peut pas l’enregistrer.",
      "restore": "Restaurer l’original"
    },
    "branding": {
      "ownCover": "Couverture de mon entreprise"
    },
    "common": {
      "done": "Terminé"
    },
    "comeback": {
      "cardText": "clients ne sont pas venus depuis au moins 3 semaines",
      "cardTextOne": "client n’est pas venu depuis au moins 3 semaines",
      "cta": "Envoyer une offre par e-mail",
      "ctaShort": "Envoyer une offre",
      "title": "Campagne de retour",
      "desc": "Votre offre sera envoyée par e-mail à",
      "desc2": "clients inactifs (ceux sans e-mail seront ignorés). Utilisez",
      "desc3": "pour personnaliser.",
      "subject": "Objet",
      "subjectPh": "Vous nous manquez ! (par défaut)",
      "message": "Message",
      "messagePh": "Bonjour {nombre}, votre dernière visite remonte à quelque temps... (message par défaut si vide)",
      "sending": "Envoi...",
      "send": "Envoyer maintenant",
      "sentOk": "Offre envoyée à {count} client(s)",
      "skipped": "{count} sans e-mail",
      "noneSent": "Aucun client inactif n’a d’adresse e-mail",
      "sendError": "Impossible d’envoyer la campagne"
    },
    "nav": {
      "relatedModules": "Modules associés"
    }
  }
};
